export type InsightsApplication = CodmanApplication | "data-request";

export type CodmanApplication =
    | "exploration"
    | "indicators"
    | "descriptives"
    | "portal"
    | "patients"
    | "patients-like-me"
    | "overview";
